// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"7eb78a9e","498":"da003fa3"}[chunkId] + ".chunk.css";
};